export default Object.freeze({
  TITLE: '파트너 신규 등록',
  NOTES: '완료를 클릭하시면 파트너사 담당자에게 정보입력이 요청됩니다.',

  ERR_NOT_CHECK_EXISTS: '중복체크한 뒤에 다시 등록해주세요.',
  ERR_EMAIL_NULL: 'e메일을 입력해주세요.',

  REGISTER_MAG: '파트너 등록이 정상적으로 요청되었습니다.',
});
